module.exports = "/images/TermsOfService.svg?3e8bf3021bb2ea421a70430d17a37e74";